import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import joborderlpoService from '../../services/joborderlpoService';

const JoborderlposFileViewer = () => {
    const location = useLocation();
    // Extract file path from the wildcard route
    const filePath = location.pathname.replace('/job_order_lpos/file/', '');
    const [fileUrl, setFileUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    useEffect(() => {
        const fetchFileUrl = async () => {
            try {
                setLoading(true);
                setError('');
                
                // Use the service method to get the file URL
                const response = await joborderlpoService.getFileUrl(filePath);
                
                // If the service returns a blob or direct response, create object URL
                if (response instanceof Blob) {
                    const url = URL.createObjectURL(response);
                    setFileUrl(url);
                } else if (response.url) {
                    setFileUrl(response.url);
                } else {
                    // Fallback: construct URL using the API endpoint
                    setFileUrl(`/api/job_order_lpos/file/${filePath}`);
                }
            } catch (err) {
                console.error('Error fetching file:', err);
                setError('Invalid file !.');
            } finally {
                setLoading(false);
            }
        };
        
        if (filePath) {
            fetchFileUrl();
        }
        
        // Cleanup object URL on unmount
        return () => {
            if (fileUrl && fileUrl.startsWith('blob:')) {
                URL.revokeObjectURL(fileUrl);
            }
        };
    }, [filePath]);
    
    const handleDownload = async () => {
        try {
            const response = await joborderlpoService.getFileUrl(filePath);
            
            let blob;
            if (response instanceof Blob) {
                blob = response;
            } else {
                // If not a blob, fetch it as blob
                const fetchResponse = await fetch(`/api/job_order_lpos/file/${filePath}`);
                blob = await fetchResponse.blob();
            }
            
            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filePath.split('/').pop(); // Get filename from path
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Download error:', err);
            alert('Failed to download file. Please try again.');
        }
    };
    
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading file...</div>
            </div>
        );
    }
    
    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div className="alert alert-danger">{error}</div>
            </div>
        );
    }
    
    return (
        <div style={{ width: '100%', height: '100vh', padding: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
                <h3>LPO File Viewer</h3>
                <p>File: {filePath}</p>
                <a 
                    href={fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                    style={{ marginRight: '10px' }}
                >
                    <i className="fa fa-external-link-alt"></i> Open in New Tab
                </a>
                <button 
                    onClick={handleDownload}
                    className="btn btn-secondary"
                >
                    <i className="fa fa-download"></i> Download File
                </button>
            </div>
            
            {/* File Viewer */}
            <div style={{ width: '100%', height: 'calc(100vh - 120px)', border: '1px solid #ddd' }}>
                <iframe
                    src={fileUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="LPO File Viewer"
                >
                    <p>
                        Your browser does not support this file type. 
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                            Click here to view the file
                        </a>
                    </p>
                </iframe>
            </div>
        </div>
    );
};

export default JoborderlposFileViewer;